import { datadogRum as Rum } from '@datadog/browser-rum';

const noop = () => {};

const noopRum = new Proxy({}, {
  get: () => noop,
});

export const datadogRum = process.env.DATADOG_ENABLED === 'true' ? Rum : noopRum;
